import {DatosMasivoGlosa, DatosGenerarFtp} from "../modelo/EnvioMasivoGlosas";

export const ENVIAR_GLOSAS_CON_CODIGO = "ENVIAR_GLOSAS_CON_CODIGO";
export const GENERAR_ARCHIVO_FTP = "GENERAR_ARCHIVO_FTP";
export const ENVIAR_MASIVO_GLOSAS= "ENVIAR_MASIVO_GLOSAS";
export const ERROR_AUTORIZACION = "ERROR_AUTORIZACION";
export const ERROR_ENVIO_GLOSAS_CON_CODIGO = "ERROR_ENVIO_GLOSAS_CON_CODIGO";
export const ERROR_ENVIO_MASIVO_GLOSAS = "ERROR_ENVIO_MASIVO_GLOSAS";
export const ENVIO_EXITOSO_GLOSAS_CON_CODIGO = "ENVIO_EXITOSO_GLOSAS_CON_CODIGO";
export const ENVIO_EXITOSO_MASIVO_GLOSAS = "ENVIO_EXITOSO_MASIVO_GLOSAS";
export const DESCARGAR_PLANTILLA_MASIVO_GLOSAS = "DESCARGAR_PLANTILLA_MASIVO_GLOSAS";
export const PLANTILLA_MASIVO_GLOSAS_OBTENIDA = "PLANTILLA_MASIVO_GLOSAS_OBTENIDA";
export const ERROR_OBTENIENDO_PLANTILLA_MASIVO_GLOSAS = "ERROR_OBTENIENDO_PLANTILLA_MASIVO_GLOSAS";
export const LIMPIAR_MENSAJES_MASIVO_GLOSAS = "LIMPIAR_MENSAJES_MASIVO_GLOSAS";
export const GENERACION_EXITOSA_ARCHIVO = "GENERACION_EXITOSA_ARCHIVO";
export const GENERACION_ARCHIVO_ERROR = "GENERACION_ARCHIVO_ERROR";

export const enviarGlosasConCodigo = (datosEnvioGlosa: DatosMasivoGlosa) => ({ type: ENVIAR_GLOSAS_CON_CODIGO, datosEnvioGlosa });
export const enviarMasivoGlosas = (archivoEnvioGlosas: File) => ({ type: ENVIAR_MASIVO_GLOSAS, archivoEnvioGlosas});
export const errorAutorizacion = () => ({ type: ERROR_AUTORIZACION});
export const errorEnvioGlosasConCodigo = (mensajeRespuesta: string) => ({ type: ERROR_ENVIO_GLOSAS_CON_CODIGO, mensajeRespuesta});
export const errorEnvioMasivoGlosas = (mensajeRespuesta: string) => ({ type: ERROR_ENVIO_MASIVO_GLOSAS, mensajeRespuesta});
export const envioExitosoGlosasConCodigo = (registrosEncontrados: number) => ({ type: ENVIO_EXITOSO_GLOSAS_CON_CODIGO, registrosEncontrados});
export const envioExitosoMasivoGlosas = () => ({ type: ENVIO_EXITOSO_MASIVO_GLOSAS});
export const descargarPlantillaMasivoGlosas = () => ({ type: DESCARGAR_PLANTILLA_MASIVO_GLOSAS});
export const plantillaMasivoGlosasObtenida = () => ({type: PLANTILLA_MASIVO_GLOSAS_OBTENIDA});
export const errorObteniendoPlantillaMasivoGlosas = () => ({type: ERROR_OBTENIENDO_PLANTILLA_MASIVO_GLOSAS});
export const limpiarMensajesMasivoGlosas = () => ({type: LIMPIAR_MENSAJES_MASIVO_GLOSAS});
export const generarArchivoFtp = (datosGenerarFtp: DatosGenerarFtp) => ({ type: GENERAR_ARCHIVO_FTP, datosGenerarFtp });
export const generacionExitosaArchivo = (registrosEncontrados: number, registrosParametro: number, correos: string) =>
 ({ type: GENERACION_EXITOSA_ARCHIVO, registrosEncontrados, registrosParametro, correos});
export const generacionArchivoError = (mensajeRespuesta: string) => ({ type: GENERACION_ARCHIVO_ERROR, mensajeRespuesta});



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_masivo_glosas/modulos/procesarMasivoGlosasActions.ts